export default {
	changelog_menu_item: 'Changelog',
	changelog_no_entries: 'No entries yet',
	changelog_section_seen: 'Already read',
	changelog_section_unseen: 'New',
	changelog_title: "What's new",
	changelog_unseen_tooltip: 'New version available',
	changelog_version_label: 'Version',
};
